import { render, staticRenderFns } from "./traslado.vue?vue&type=template&id=59e4ba12"
import script from "./traslado.vue?vue&type=script&lang=js"
export * from "./traslado.vue?vue&type=script&lang=js"
import style0 from "./traslado.vue?vue&type=style&index=0&id=59e4ba12&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports